import { BaseDivider } from "@/shared/ui/base-divider";
import { SidebarListItem } from "@/widgets/sidebar/ui/sidebar-list-item";
import { List } from "@mui/material";

type Props = {
  currentPath: string;
  notificationBadgeNumber: number | undefined;
  logout: () => void;
};

export const ShipperSidebar = ({
  currentPath,
  notificationBadgeNumber,
  logout,
}: Props) => {
  return (
    <>
      <List>
        <SidebarListItem
          href="/notifications"
          text="お知らせ"
          icon="mail"
          isActive={currentPath === "/notifications"}
          badgeNumber={notificationBadgeNumber}
        />

        <SidebarListItem
          href="/shipper/cargos"
          text="マイ荷物"
          icon="package"
          isActive={currentPath === "/shipper/cargos"}
        />
      </List>

      <BaseDivider />

      <List>
        <SidebarListItem
          href="#"
          text="ヘルプ"
          icon="helpCircle"
          isActive={false}
        />
        <SidebarListItem
          text="ログアウト"
          icon="logOut"
          isActive={false}
          onClick={logout}
        />
      </List>
    </>
  );
};
